/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllAccess } from './accessAction';
 
const initialState = {
    data: {},
    accessList: {},
 }
const accessSlice = createSlice({
    name: 'access',
    initialState,
    extraReducers: {

        [getAllAccess.fulfilled]: (state, { payload }) => {
            state.accessList =  payload;
        },
        [getAllAccess.rejected]: (state, { payload }) => {
            state.accessList =  {};
        },
        
    }
});

export default accessSlice.reducer